var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMlWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.5,
    height: 21.499,
    viewBox: "0 0 21.5 21.499",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-5 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2, .cls-3, .cls-4 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2, .cls-3, .cls-4, .cls-5 {\r\n        stroke: #fff;\r\n        stroke-linecap: round;\r\n        stroke-width: 1.5px;\r\n      }\r\n\r\n      .cls-2, .cls-3 {\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke-miterlimit: 10;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12244",
    "data-name": "Group 12244",
    transform: "translate(22068.75 7492.75)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1830",
    "data-name": "Ellipse 1830",
    className: "cls-1",
    cx: 1.542,
    cy: 1.571,
    rx: 1.542,
    ry: 1.571,
    transform: "translate(-22059.434 -7484.351)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7162",
    "data-name": "Path 7162",
    className: "cls-2",
    d: "M23.058,9.291A4.807,4.807,0,0,1,21.2,5.476a4.685,4.685,0,1,1,9.369,0,4.847,4.847,0,0,1-1.858,3.815",
    transform: "translate(-22083.719 -7492.7)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10173",
    "data-name": "Group 10173",
    transform: "translate(-22068 -7481.904)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7163",
    "data-name": "Path 7163",
    className: "cls-3",
    d: "M53.573,1.784a9.964,9.964,0,0,1,3.982,2.342",
    transform: "translate(-40.517 -1.747)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7164",
    "data-name": "Path 7164",
    className: "cls-4",
    d: "M7.291,0A10.312,10.312,0,0,1,0,9.9",
    transform: "translate(7.291 9.903) rotate(180)"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_1268",
    "data-name": "Line 1268",
    className: "cls-4",
    x2: 14.5,
    transform: "translate(-22062.5 -7472.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7478",
    "data-name": "Path 7478",
    className: "cls-5",
    d: "M7,0h7.5",
    transform: "translate(-22062.5 -7476.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMlWhite);
export default __webpack_public_path__ + "static/media/mlWhite.2a34152b0456666c550c4bc6d552db24.svg";
export { ForwardRef as ReactComponent };